import { render } from "./ShareholderDomesticCorporate.vue?vue&type=template&id=046d5bae&scoped=true&ts=true"
import script from "./ShareholderDomesticCorporate.vue?vue&type=script&lang=ts"
export * from "./ShareholderDomesticCorporate.vue?vue&type=script&lang=ts"

import "./ShareholderDomesticCorporate.vue?vue&type=style&index=0&id=046d5bae&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046d5bae"]])

export default __exports__